import PropTypes from 'prop-types';

export const SourceOptionsType = Object.freeze({
    displayedWord: PropTypes.string.isRequired,
    onClickItem: PropTypes.func.isRequired,
    isFixedWidth: PropTypes.bool.isRequired,
});

